import { Add, Close } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { ChipPicker, Picker } from '../ChipPicker';

import s from './ChipsField.module.scss';

export type FieldChip = {
  id: string;
  label: string;
  /** Пояснение после названия: доска спринта, его статус */
  hint?: string;
  to: string;
  removeLabel: string;
};

type Props<T> = {
  chips: FieldChip[];
  disabled: boolean;
  addText: string;
  onRemove: (id: string) => void;
  picker: Picker<T>;
};

/** Связи задачи чипами-ссылками: убрать крестиком, добавить из списка — как блок Agile в Яндекс Трекере */
const ChipsField = <T,>({ chips, disabled, addText, onRemove, picker }: Props<T>) => {
  const [isAdding, setIsAdding] = useState(false);

  return (
    <div className={s.chips}>
      {chips.map((chip) => (
        <Chip
          key={chip.id}
          size="small"
          className={s.chips__chip}
          title={chip.hint ? `${chip.label} · ${chip.hint}` : chip.label}
          label={
            <>
              <Link to={chip.to} className={s.chips__link}>
                {chip.label}
              </Link>
              {chip.hint && <span className={s.chips__hint}> · {chip.hint}</span>}
            </>
          }
          onDelete={disabled ? undefined : () => onRemove(chip.id)}
          deleteIcon={<Close aria-label={chip.removeLabel} />}
        />
      ))}

      {!chips.length && !isAdding && <span className={s.chips__empty}>—</span>}

      {isAdding && <ChipPicker picker={picker} onClose={() => setIsAdding(false)} />}

      {!isAdding && !disabled && (
        <button type="button" className={s.chips__add} onClick={() => setIsAdding(true)}>
          <Add fontSize="inherit" />
          {addText}
        </button>
      )}
    </div>
  );
};

export { ChipsField };
